import { render, staticRenderFns, recyclableRender, components } from "./using-workers.vue?vue&type=template&id=b2e704c0&scoped=true&"
var renderjs
import script from "./using-workers.vue?vue&type=script&lang=js&"
export * from "./using-workers.vue?vue&type=script&lang=js&"
import style0 from "./using-workers.vue?vue&type=style&index=0&lang=css&"
import style1 from "./using-workers.vue?vue&type=style&index=1&id=b2e704c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e704c0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/using-workers/using-workers.vue"
export default component.exports